import React from 'react'
import "../App.scss";
import { Text, View, StyleSheet, Dimensions } from 'react-native'
import Loadingscreen from "../Utils/defaultLoader";
const actualWidth = Dimensions.get('screen').width;
const Index = () => {
  return (
    <View
      style={{
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "var(--mandg-alt-background)",
      }}
    >
      <View
        style={{
          justifyContent: "center",
          alignItems: "center",
          height: "10%",
        }}
      >
        <div className="af-class-large">
          Please wait, submitting your answers
        </div>
      </View>
      <View
        style={{
          justifyContent: "center",
          alignItems: "center",
          height: "10%",
        }}
      >
        <Loadingscreen />
      </View>
    </View>
  );
}

export default Index;

const styles = StyleSheet.create({
  Container: {},
  text: {
    // textAlign: "center",
    // fontFamily: "Infra",
    // fontSize: actualWidth > 600 ? 34 : actualWidth > 380 ? 28 : 24,
    // color: "#2f2f2f",
    // lineHeight: 40,
    // fontWeight: "bold",
  },
});